import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14" aria-labelledby="faq" data-id="element-140" data-mp="121tqbfciaksg">
      <div className="mx-auto w-full max-w-2xl" data-id="element-141" data-mp="1ps7j582x0no3">
        <h2 id="faq" className="text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-142" data-mp="1ptirll7b2jlj">
          Preguntas frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-143" data-mp="1g1motwu9y5az">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy/10 bg-cream" data-id="element-144" data-mp="28r22kudbqcal" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-145" data-mp="2dik1lcvse2sx">
                  <span className="text-[15px] font-bold leading-snug text-navy" data-id="element-146" data-mp="2yh3is3ul7z2y">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brandred transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-147" data-mp="2to0n9q692fk4" />
                </button>
                <AnimatePresence initial={false} data-id="element-148" data-mp="3hdl9chxp9sxm">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-149" data-mp="3cgus3ra5sram">
                      <p className="px-4 pb-4 text-[15px] leading-relaxed text-navy/70" data-id="element-150" data-mp="27qfoigjmkk74">
                        {faq.a}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-8" data-id="element-151" data-mp="2lq8eg9nbuwe1">
          <CTAButton label="Resolví mis dudas, quiero empezar" data-id="element-152" data-mp="2lqi41w4gn1j7" />
        </div>
      </div>
    </section>;
}